//imgs
import img01 from "../../assets/images/chapters/05/01.jpg";

import img02 from "../../assets/images/chapters/05/02.jpg";
import img03 from "../../assets/images/chapters/05/03.jpg";
import img04 from "../../assets/images/chapters/05/04.jpg";
import img05 from "../../assets/images/chapters/05/05.jpg";

import img06 from "../../assets/images/chapters/05/06.jpg";
import img07 from "../../assets/images/chapters/05/07.jpg";

import img08 from "../../assets/images/chapters/05/08.jpg";
import img09 from "../../assets/images/chapters/05/09.jpg";
import img10 from "../../assets/images/chapters/05/10.jpg";

import { captions } from "../../assets/data/chapters/chapter05";

//scroll reveal
import ScrollReveal from "../scrollReveal";

const Chapter = () => {
  return (
    <div id="chapter05">
      <div className="group01">
        <ScrollReveal className="title">PAD↑{"\n"}39a</ScrollReveal>
        <ScrollReveal className="picture">
          <img src={img01} alt="" />
          <p className="caption">{captions[0]}</p>
        </ScrollReveal>
      </div>
      <div className="group02">
        <div className="row">
          <div className="column">
            <ScrollReveal className="picture">
              <img src={img02} alt="" />
              <p className="caption">{captions[1]}</p>
            </ScrollReveal>
            <ScrollReveal className="title">LC-39</ScrollReveal>
          </div>
          <div className="column">
            <ScrollReveal className="picture">
              <img src={img03} alt="" />
              <p className="caption">{captions[2]}</p>
            </ScrollReveal>
          </div>
          <div className="column">
            <ScrollReveal className="picture">
              <img src={img04} alt="" />
              <p className="caption">{captions[3]}</p>
            </ScrollReveal>
            <ScrollReveal className="picture">
              <img src={img05} alt="" />
              <p className="caption">{captions[4]}</p>
            </ScrollReveal>
          </div>
        </div>
      </div>

      <div className="group03">
        <ScrollReveal className="title">
          <span>
            john f. {"\n"}kennedy{"\n"}space center
          </span>
        </ScrollReveal>
        <ScrollReveal className="picture">
          <img src={img06} alt="" />
          <p className="caption">{captions[5]}</p>
        </ScrollReveal>
        <ScrollReveal className="picture">
          <img src={img07} alt="" />
          <p className="caption">{captions[6]}</p>
        </ScrollReveal>
      </div>

      <div className="group04">
        <ScrollReveal className="title">
          <span>↑lift-off↑</span>
          <span>↑lift-off↑</span>
          <span>↑lift-off↑</span>
        </ScrollReveal>
        <div className="row">
          <div className="column">
            <ScrollReveal className="picture">
              <img src={img08} alt="" />
              <p className="caption">{captions[7]}</p>
            </ScrollReveal>
          </div>
          <div className="column">
            <ScrollReveal className="picture">
              <img src={img09} alt="" />
              <p className="caption">{captions[8]}</p>
            </ScrollReveal>
          </div>
          <div className="column">
            <ScrollReveal className="picture">
              <img src={img10} alt="" />
              <p className="caption">{captions[9]}</p>
            </ScrollReveal>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Chapter;
